import React, { FC } from "react";

const ModalHeader: FC = ({ children }) => {
  return <div className="modal-header">{children}</div>;
};

export default ModalHeader;
